import { ROUTE_VIEW } from './constants.js';
import { createHomeController } from './controllers/home-controller.js';
import { createSlidesController } from './controllers/slides-controller.js';
import { createSummaryController } from './controllers/summary-controller.js';
import { bindButtonTracking, trackPageView } from './gtm.js';
import { updatePageMeta } from './meta.js';
import { createAssetPreloader } from './preload.js';
import { buildRouteUrl, normalizeRoute, resolveInitialRoute } from './routes.js';

export function initAppShell() {
  const appRoot = document.querySelector('[data-app-root]');
  if (!appRoot) {
    return;
  }

  bindButtonTracking(appRoot);

  const views = {
    home: appRoot.querySelector('[data-route-view="home"]'),
    slides: appRoot.querySelector('[data-route-view="slides"]'),
    summary: appRoot.querySelector('[data-route-view="summary"]')
  };

  const preloader = createAssetPreloader(appRoot);
  let currentRoute = '';
  let currentViewName = '';

  function navigateTo(route) {
    const nextRoute = normalizeRoute(route);
    if (!nextRoute || currentRoute === nextRoute) {
      return;
    }

    window.location.hash = nextRoute;
  }

  const controllers = {
    home: createHomeController(views.home, navigateTo, preloader),
    slides: createSlidesController(views.slides, navigateTo, preloader),
    summary: createSummaryController(views.summary, navigateTo, preloader)
  };

  function applyRoute(route) {
    const nextRoute = normalizeRoute(route) || resolveInitialRoute(appRoot);
    const nextViewName = ROUTE_VIEW[nextRoute];
    const nextView = views[nextViewName];

    if (!nextView) {
      return;
    }

    if (currentViewName && currentViewName !== nextViewName && controllers[currentViewName]) {
      controllers[currentViewName].leave();
    }

    Object.keys(views).forEach(function (viewName) {
      if (!views[viewName]) {
        return;
      }

      views[viewName].hidden = viewName !== nextViewName;
    });

    document.body.setAttribute('data-app-route', nextRoute);
    updatePageMeta(nextRoute, nextView);

    if (controllers[nextViewName]) {
      controllers[nextViewName].enter(nextRoute);
    }

    trackPageView(appRoot, nextRoute);

    currentRoute = nextRoute;
    currentViewName = nextViewName;
  }

  window.addEventListener('hashchange', function () {
    applyRoute(window.location.hash);
  });

  const initialRoute = resolveInitialRoute(appRoot);
  history.replaceState(null, '', buildRouteUrl(initialRoute));

  if (initialRoute === 'cover' || initialRoute === 'intro' || initialRoute === 'slides') {
    preloader.preloadSlide(0);
  } else if (initialRoute === 'summary') {
    preloader.preloadSummary();
  }

  applyRoute(initialRoute);
}
